module.exports = __webpack_public_path__ + "img/type-2.a7aaff2.png";